export const formatDate = (unformattedDate: string) => {
  let date = unformattedDate;
  if (unformattedDate.replace) {
    date = unformattedDate.replace('@', '');
  }
  const dateObject = new Date(date);
  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(dateObject);
};
